import { useNavigate } from '@tanstack/react-router';
import { Button, Typography } from '@volvo/vcdk-react';

import type { ErrorComponentProps } from '@tanstack/react-router';

export const ErrorBoundary = ({ error }: ErrorComponentProps) => {
  const navigate = useNavigate();

  const normalizedError = error instanceof Error ? error : new Error(String(error));
  const errorMessage = normalizedError.message || 'An unexpected error occurred';
  const errorStatus = 'Error';

  const handleGoHome = () => {
    navigate({ to: '/dashboard' });
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="border-subtle flex items-center justify-center rounded border bg-white p-6">
      <div className="w-full max-w-md space-y-6 text-center">
        <div className="flex flex-col space-y-2">
          <Typography variant="heading1" className="text-content-primary">
            {errorStatus}
          </Typography>
          <Typography variant="heading3" className="text-content-secondary">
            Oops! Something went wrong
          </Typography>
        </div>

        <div className="bg-surface-secondary rounded-lg p-4">
          <Typography variant="body" className="text-content-primary wrap-break-word">
            {errorMessage}
          </Typography>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button variant="primary" onClick={handleGoHome}>
            Go to Dashboard
          </Button>
          <Button variant="secondary" onClick={handleGoBack}>
            Go Back
          </Button>
        </div>

        {import.meta.env.DEV && normalizedError.stack && (
          <details className="mt-6 text-left">
            <summary className="text-content-secondary hover:text-content-primary cursor-pointer text-sm">
              Stack trace (dev only)
            </summary>
            <pre className="bg-surface-tertiary mt-2 overflow-auto rounded p-3 text-xs">{normalizedError.stack}</pre>
          </details>
        )}
      </div>
    </div>
  );
};
